import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from '../login/auth.service';

export interface UploadFilePrice {
  provider_id: number;
  description_column: string;
  article_column: string;
  brand_column: string;
  price_column: string;
  delimiter: string;
  warehouses: { wh_id: number; column: string }[];
  file: File;
}

@Injectable({
  providedIn: 'root'
})
export class ProviderPriceService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  uploadPriceFile(payload: UploadFilePrice) {
    const formData: FormData = new FormData();
    formData.set('file', payload.file);
    formData.set('provider_id', String(payload.provider_id));
    formData.set('description_column', String(payload.description_column));
    formData.set('article_column', String(payload.article_column));
    formData.set('brand_column', String(payload.brand_column));
    formData.set('price_column', String(payload.price_column));
    formData.set('warehouses', JSON.stringify(payload.warehouses));
    formData.set('delimiter', String(payload.delimiter));
    return this.http.post(`${environment.BACKEND}/provider-price/upload`, formData);
  }

  getProducts() {
    return this.http.get(`${environment.BACKEND}/provider-price/products`);
  }

  getNewBrands() {
    return this.http.get<{ brand: string }[]>(`${environment.BACKEND}/provider-price/new_brands`);
  }

  getNewArticles() {
    return this.http.get<{ brand: string; article: string }[]>(
      `${environment.BACKEND}/provider-price/new_articles`
    );
  }
}
